export const scrollToSection = (id) => {
  const tryScroll = (attempts) => {
    const el = document.getElementById(id);
    if (el) {
      const lenis = window.__lenis;
      if (lenis) {
        lenis.scrollTo(el, { offset: -100, duration: 1.2 });
      } else {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
      return;
    }
    if (attempts < 25) setTimeout(() => tryScroll(attempts + 1), 100);
  };
  tryScroll(0);
};
